import React, { useState, useEffect } from "react";
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import { useNavigate } from 'react-router-dom';
import { Mail, Mails, ArrowDownAZ, ArrowUpAZ, X } from "lucide-react";
import Loader from "../../visualComponents/Loader.js";
import Tooltip from "../../components/Tooltip.js";

let isLoading = false;

const PopUpMail = ({ isVisible, setIsVisible, data }) => {
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [utenti, setUtenti] = useState([]);

    useEffect(() => {
        if (isVisible && data) {
            loadUtenti();
        }
    }, [isVisible]);

    const loadUtenti = async () => {
        try {
            isLoading = true;
            const response = await fetch("/getUtentiByGestione", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    IDAzienda: data["IDAzienda"]
                }),
            });

            const responseData = await response.json();

            if (response.status === 500) {
                alert(responseData.error);
                console.log(responseData.error);
                window.location.reload();
            } else {
                isLoading = false;
                setUtenti(responseData.filter((d) => d["DataEliminazione"] === null));
            }
        } catch (error) {
            alert("Errore nel caricamento degli utenti");
            console.log(error);
            window.location.reload();
        }
    };

    const addUser = (IDUtente) => {
        const select = document.getElementById("selectUtente");
        if (IDUtente === "") {
            alert("Seleziona un utente");
            return;
        }
        if (selectedUsers.includes(IDUtente)) {
            alert("Utente già selezionato");
            return;
        }
        setSelectedUsers([...selectedUsers, utenti.find((d) => d["ID"] === Number(IDUtente))]);
        select.value = "";
    };

    const handleRimuoviUtente = (ID) => {
        setSelectedUsers(selectedUsers.filter((d) => d["ID"] !== Number(ID)));
    };

    const closeModal = () => {
        setIsVisible(false);
    };

    const handleSendAll = async () => {
        try {
            isLoading = true;
            const response = await fetch("/sendManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Utenti: utenti,
                    Componente: data
                })
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            }
            else {
                isLoading = false;
                alert("Mail inviata con successo");
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'invio della mail");
            console.log(error);
            window.location.reload();
        }
    };

    const handleSend = async () => {
        try {
            isLoading = true;
            const response = await fetch("/sendManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    Utenti: selectedUsers,
                    Componente: data
                })
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            } else {
                isLoading = false;
                alert("Mail inviata con successo");
                window.location.reload();
            }
        } catch (error) {
            alert("Errore nell'invio della mail");
            console.log(error);
            window.location.reload();
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">Mail di notifica</h2>
                    <Tooltip content="Chiudi">
                        <button className="text-red-500" onClick={closeModal}>
                            <X size={24} />
                        </button>
                    </Tooltip>
                </div>
                <div className='flex justify-center'>
                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleSendAll}>
                        Invia a tutti gli utenti
                    </button>
                </div>
                <div className="flex justify-center mt-2">
                    Oppure
                </div>
                <div>
                    <div className="grid grid-cols-2 gap-4 mt-4">
                        <p className="">Utente:</p>
                        <select id="selectUtente" className="rounded border-2 border-gray-300 dark:border-gray-600 w-full bg-white dark:bg-gray-800" onChange={(e) => { addUser(e.target.value) }}>
                            <option value="">Seleziona gli utenti</option>
                            {
                                utenti.map((d, index) => (
                                    <option key={index} value={d["ID"]}>{d["Nome"]} {d["Cognome"]}</option>
                                ))
                            }
                        </select>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mt-4 text-center">
                        {
                            selectedUsers.map((d, index) => (
                                <div key={index} className="grid grid-cols-1 items-center bg-gray-300 dark:bg-gray-500 p-1 rounded border-2 border-solid border-black dark:border-white">
                                    {d["Nome"]}
                                    <button className="justify-self-center text-red-500 dark:text-red-700" onClick={() => handleRimuoviUtente(d["ID"])}><X size={15} /></button>
                                </div>
                            ))
                        }
                    </div>
                    <div className='flex justify-center'>
                        <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleSend}>
                            Invia
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const TableRow = ({ data }) => {
    const [popUpVisible, setPopUpVisible] = useState(false);

    return (
        <div className="grid grid-cols-6 gap-4 mt-2">
            <div></div>
            <div
                className={`col-span-4 bg-gray-300 dark:bg-gray-500 rounded-lg grid grid-cols-4
                p-4 text-center divide-x divide-black dark:divide-white break-words
                ${data["StatoAttuale"] === "In Scadenza" ? "border-2 border-orange-500" : (
                        data["StatoAttuale"] === "Scaduto" ? "border-2 border-red-600" : null
                    )
                    }`}
            >
                <div>{data.Codice === "" ? ("-----") : (data.Codice)}</div>
                <div>{data.Descrizione === "" ? ("-----") : (data.Descrizione)}</div>
                <div>{data.Nome}</div>
                <div>{data.ProssimaManutenzione}</div>
            </div>
            <div className="flex items-center">
                <Tooltip content="Invio mail">
                    <button className="text-blue-600" onClick={() => setPopUpVisible(true)}>
                        <Mail size={24} />
                    </button>
                </Tooltip>
            </div>
            <PopUpMail
                isVisible={popUpVisible}
                setIsVisible={setPopUpVisible}
                data={data}
            />
        </div>
    );
};
const DashManager = () => {
    const navigate = useNavigate();
    const [indexTabella, setIndexTabella] = useState([
        { value: "Componente", dbCode: "Codice", ascending: true, filter: "text" },
        { value: "Descrizione", dbCode: "Descrizione", ascending: true, filter: "text" },
        { value: "Cliente", dbCode: "Nome", ascending: true, filter: "text" },
        { value: "Scadenza Manutenzione", dbCode: "ProssimaManutenzione", ascending: true, filter: "text" }
    ]);
    const [filters, setFilters] = useState({
        Codice: "",
        Descrizione: "",
        Nome: "",
        ProssimaManutezione: ""
    });
    const [data, setData] = useState([]);
    const [viewData, setViewData] = useState([]);
    const [numeroAziende, setNumeroAziende] = useState(0);
    const [numeroUtenti, setNumeroUtenti] = useState(0);
    const [numeroComponenti, setNumeroComponenti] = useState(0);

    useEffect(() => {
        onload()
    }, []);

    useEffect(() => {
        let newData = [...data];
        for (const key in filters) {
            if (filters[key] !== "") {
                newData = newData.filter((d) => (d.value[key] !== null ? d.value[key].toString().toLowerCase().includes(filters[key].toLowerCase()) : null));
            }
        };
        setViewData(newData);
    }, [filters]);

    useEffect(() => {
        setViewData(data);
    }, [data]);

    const onload = async () => {
        try {
            isLoading = true;
            await loadNav();
            const r1 = await fetch("/getConteggi", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] })
            });

            const rd1 = await r1.json();

            if (r1.status === 500) {
                alert(rd1.error);
                console.log(rd1.error);
                navigate('/');
            }
            else {
                setNumeroAziende(rd1["Aziende"]);
                setNumeroUtenti(rd1["Utenti"]);
                setNumeroComponenti(rd1["Componenti"]);

                //loadTabella
                const r2 = await fetch("/getComponentiInScadenza", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] })
                });

                const rd2 = await r2.json();

                if (r2.status === 500) {
                    alert(rd2.error);
                    console.log(rd2.error);
                    navigate('/');
                }
                else {
                    isLoading = false;
                    setData(rd2.map(item => ({ value: item })));
                }

            }
        } catch (error) {
            alert("Errore nel caricamento della pagina, riprova più tardi");
            console.log(error);
            navigate('/');
        }
    };

    const sortByColumn = (column) => {
        setIndexTabella((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabella.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewData];

        newData.sort((a, b) => {
            const valA = a.value[column];
            const valB = b.value[column];

            const isDateFormat = typeof valA === "string" && /^\d{2}\/\d{2}\/\d{4}$/.test(valA);

            if (isDateFormat) {
                const dateA = parseDate(valA);
                const dateB = parseDate(valB);
                return isAscending ? dateA - dateB : dateB - dateA;
            }

            if (valA > valB) return isAscending ? -1 : 1;
            if (valA < valB) return isAscending ? 1 : -1;
            return 0;
        });

        setViewData(newData);
    };

    const parseDate = (str) => {
        const [day, month, year] = str.split('/');
        return new Date(`${year}-${month}-${day}`);
    };

    const sendNotifyToAll = async () => {
        try {
            isLoading = true;
            const response = await fetch("/sendAllManutenzioni", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
                window.location.reload();
            } else {
                isLoading = false;
                alert("Mail inviata con successo");
                window.location.reload();
            }

        } catch (error) {
            alert("Errore nell'invio della mail");
            console.log(error);
            window.location.reload();
        }
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page={"HOME"} />
            {isLoading && <Loader />}
            <div className="p-4 bg-white dark:bg-gray-800 text-black dark:text-white">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-14">
                    <div className="w-full h-32 bg-red-500 dark:bg-red-700 rounded-lg justify-center items-center flex cursor-pointer" onClick={() => navigate('/dashManager/aziende')}>
                        <Tooltip content="Pagina con tutti i clienti">
                            <div className=" text-center">
                                <p className="text-2xl font-bold">Clienti</p>
                                <p>Numero clienti: {numeroAziende}</p>
                            </div>
                        </Tooltip>
                    </div>
                    <div className="w-full h-32 bg-blue-500 dark:bg-blue-700 rounded-lg justify-center items-center flex cursor-pointer" onClick={() => navigate('/dashManager/utenti')}>
                        <Tooltip content="Pagina con tutti gli utenti">
                            <div className=" text-center">
                                <p className="text-2xl font-bold">Utenti</p>
                                <p>Numero utenti: {numeroUtenti}</p>
                            </div>
                        </Tooltip>
                    </div>
                    <div className="w-full h-32 bg-green-500 dark:bg-green-700 rounded-lg justify-center items-center flex cursor-pointer" onClick={() => navigate('/dashManager/magazzino')}>
                        <Tooltip content="Pagina con tipologie e stati">
                            <div className=" text-center">
                                <p className="text-2xl font-bold">Magazzino</p>
                                <p>Tipologia e Operazioni</p>
                            </div>
                        </Tooltip>
                    </div>
                    <div className="w-full h-32 bg-yellow-500 dark:bg-yellow-700 rounded-lg justify-center items-center flex cursor-pointer" onClick={() => navigate('/dashManager/componenti')}>
                        <Tooltip content="Pagina con tutti i componenti">
                            <div className=" text-center">
                                <p className="text-2xl font-bold">Anagrafica articoli</p>
                                <p>Numero componenti: {numeroComponenti}</p>
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div>
                    <div className="grid grid-cols-6 gap-4 mt-4">
                        <div></div>
                        <div className="col-span-4 bg-gray-400 dark:bg-gray-600 rounded-lg grid grid-cols-4 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} onClick={() => sortByColumn(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                        <Tooltip content="Ordina">
                                            <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                            </button>
                                        </Tooltip>
                                    </div>
                                ))
                            }
                        </div>
                        <div className="flex items-center">
                            <Tooltip content="Mail a tutti">
                                <button className="text-blue-600" onClick={sendNotifyToAll}>
                                    <Mails size={24} />
                                </button>
                            </Tooltip>
                        </div>
                    </div>
                    <div className="grid grid-cols-6 gap-4 mt-2">
                        <div></div>
                        <div className="col-span-4 rounded-lg grid grid-cols-4 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                            {
                                indexTabella.map((d, index) => (
                                    <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 3 ? "pl-2" : "px-2"}`}>
                                        <input
                                            type={d.filter}
                                            placeholder={d.value}
                                            value={filters[d.dbCode]}
                                            className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                            onChange={(e) => setFilters({ ...filters, [d.dbCode]: e.target.value })}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                        <div></div>
                    </div>
                    {viewData.map((d, index) => (
                        <TableRow key={index} data={d.value} />
                    ))}
                </div>

            </div>
        </div>
    );
};

export default DashManager;